export default "__VITE_ASSET__52dfcd41__"